import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Typography.module.css';
export const Link = forwardRef(({ variant = 'default', size = 'base', external = false, className = '', children, ...props }, ref) => {
    const classes = [
        styles.link,
        styles[`link${variant.charAt(0).toUpperCase() + variant.slice(1)}`],
        styles[`text${size.charAt(0).toUpperCase() + size.slice(1)}`],
        className,
    ]
        .filter(Boolean)
        .join(' ');
    const externalProps = external
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : {};
    return (_jsx("a", { ref: ref, className: classes, ...externalProps, ...props, children: children }));
});
Link.displayName = 'Link';
